export const CONTACT_EMAIL = 'bychubkz@gmail.com';

const FORMSUBMIT_ID = process.env.REACT_APP_FORMSUBMIT_ID || '1f0b622510cc0932aebb1a2c2b01116b';

export const MEETING_FORM_ENDPOINT = `https://formsubmit.co/ajax/${FORMSUBMIT_ID}`;

export const submitMeetingRequest = async (payload, { signal } = {}) => {
  const response = await fetch(MEETING_FORM_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
    signal,
  });

  if (!response.ok) {
    throw new Error(`Meeting request failed with status ${response.status}`);
  }

  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    const data = await response.json();
    const successFlag = data?.success;

    if (successFlag === 'false' || successFlag === false) {
      throw new Error('Meeting request rejected');
    }

    return data;
  }

  await response.text();
  return { success: true };
};

export const buildContactMailto = (subject = '') => {
  const params = new URLSearchParams();

  if (subject) {
    params.set('subject', subject);
  }

  const query = params.toString();

  return query ? `mailto:${CONTACT_EMAIL}?${query}` : `mailto:${CONTACT_EMAIL}`;
};
